module.exports = __webpack_public_path__ + "static/IPSLogo-872a5decf54605402dec9d390f5573b1.png";